import React, { useEffect, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '../assets/Icons/WarningIcon';
import MButton from './MButton';
import '../style/common/confirm-dialog.scss'

const AlertModal = (props) => {
    const { open, onClose, message, severity = 'success', btnText = 'GO BACK', nextId = '' } = props;


    const buttonRef = useRef(null);
    useEffect(() => {
        if (open) {
            setTimeout(() => {
                if (buttonRef.current) {
                    buttonRef.current.focus();
                }
            }, 50);
        }
    }, [open]);


    const handleClose = () => {
        onClose(false, nextId);
    };
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        width: '350px',
                        maxWidth: 'none',
                        maxHeight: 'none',
                        padding: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: severity === 'success' ? '#E0EFD8' : severity === 'error' ? '#FFF2E2' : '',
                        boxShadow: 'none',
                        textAlign: 'center',
                        borderRadius: '10px',
                        gap: '16px'
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title"
                    sx={{ padding: '0px' }}
                    style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                    {severity === 'success' ? (
                        <>
                            <CheckCircleIcon style={{ color: '#3C763C', fontSize: '40px' }} />
                            <span style={{ color: '#3C763C', fontWeight: '500', lineHeight: '28px', fontSize: '20px' }}>Success !</span>
                        </>
                    ) : (
                        <>
                            <WarningIcon />
                        </>
                    )}
                </DialogTitle>

                <DialogContent
                    sx={{
                        padding: '0px'
                    }}
                >
                    <DialogContentText id="alert-dialog-description" style={{
                        fontSize: '16px',
                        fontWeight: 500,
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: severity === 'success' ? '#3C763C' : severity === 'error' ? '#F05924' : '',
                        fontFamily: 'Roboto',
                        textAlign: 'center',

                    }}>
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ width: '100%' }}>
                    <MButton btnName={btnText} variant='contained' onClick={handleClose} ref={buttonRef}
                        style={{ width: '100%' }} />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default AlertModal;
